// imports
import Overlay from 'minsky-kit/js/components/Overlay';
import SearchWidgetApp from '../../vue/apps/SearchWidgetApp';

// private statics
const VERSION = '1.0.0';

// class definition
export default class MenuOverlay extends Overlay {
    // constructor
    constructor(args = {}, objectName = 'Menu-Overlay') {
        args.debug = args.debug || false;
        args.keepInDom = true;
        // super
        super(args, objectName);

        this.searchWidgetApp = null;
    }

    destroy() {
        // super destroy
        super.destroy();
    }

    show() {
        this.triggers[0].classList.add('active');

        if (!this.searchWidgetApp) {
            if (this.$el.querySelector('.js-search-widget')) {
                const $widget = this.$el.querySelector('.js-search-widget');
                this.searchWidgetApp = new SearchWidgetApp({
                    $el: $widget,
                    drupal: Drupal,
                    type: 'menu-overlay'
                });
            }
        }

        super.show();
    }

    hide() {
        // console.log(this);
        this.triggers[0].classList.remove('active');
        super.hide();
    }

    // getters & setters
    static get version() { return VERSION; }
}
